import componentsCache from '@atlassian/jira-cache/src/services/components/index.tsx';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import FetchError from '@atlassian/jira-fetch/src/utils/errors.tsx';
import { getErrorMessage } from '../../common/services/index.tsx';
import {
	deleteComponent as restDeleteComponent,
	getComponentRelatedIssueCount as restGetComponentRelatedIssueCount,
} from '../rest/delete.tsx';

export const deleteComponent = async (
	componentId: string,
	moveIssuesTo?: string,
): Promise<{
	id: string | undefined;
}> => {
	const result = await restDeleteComponent(componentId, moveIssuesTo);
	if (result.ok) {
		try {
			componentId && componentsCache.remove(componentId.toString());
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			log.safeErrorWithoutCustomerData(
				'project-directories.components.cache.remove',
				error.message,
			);
		}

		return { id: componentId };
	}

	const error = await getErrorMessage(result);
	throw new FetchError(result.status, error);
};

export const getComponentRelatedIssueCount = async (
	componentId: string,
): Promise<{
	id: string;
	issueCount: number;
}> => {
	const result = await restGetComponentRelatedIssueCount(componentId);
	if (result.ok) {
		const json = await result.json();
		return {
			id: componentId,
			issueCount: json.issueCount,
		};
	}

	const error = await getErrorMessage(result);
	throw new FetchError(result.status, error);
};
